import styled from "styled-components";
import { Box, Card, Typography } from "@mui/material";

export const Title = styled(Typography)`
  && {
    font-family: Noto Serif;
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 30px;
    letter-spacing: 0.05em;
    color: #000000;
    margin-bottom: 65px;
  }
`;

export const CardBody = styled(Card)`
  && {
    background: #ffffff;
    border: 0.5px solid #c4c4c4;
    box-shadow: -2px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 15px 0px;
  }
`;

export const ReviewBody = styled(Typography)`
  && {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 30px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #000000;
  }
`;

export const CardImage = styled(Box)`
  && {
    width: 120px;
    height: 120px;
    position: relative;
    margin: auto;
    margin-bottom: -40px;
  }
`;

export const Name = styled(Typography)`
  && {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #000000;
  }
`;

export const Designation = styled(Typography)`
  && {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #000000;
  }
`;
